import { render, staticRenderFns } from "./agreementview.vue?vue&type=template&id=362b4d5b&"
import script from "./agreementview.vue?vue&type=script&lang=js&"
export * from "./agreementview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports